import { Box, Drawer, DrawerBody, DrawerContent, DrawerOverlay, Flex, useDisclosure } from '@chakra-ui/react';
import { Button, ChevronLeft, Icon } from '@mesh.ai/rabbit';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';

import { NetchexHamburger, NetchexClose } from 'assets/assetsV1/iconComponents';

import { netchexRoutes } from 'constants/netChexConstants';

import { TextBodyLarge } from 'uiToolkitV1/Typography';

import { AccordionNavigation } from './AccordionNavigation';

const GotoHomeButton = () => (
  <Box
    style={{
      position: 'absolute',
      // left: '10px',
      zIndex: 13,
      // height: '60px',
      marginTop: '-50px',
      lineHeight: '55px',
    }}
  >
    <a
      href={netchexRoutes.dashboard}
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Button
        style={{
          color: '#9ca3af',
          fontSize: '20px',
          fontWeight: 'normal',
        }}
        variant="text"
        iconLeft={ChevronLeft}
      >
        Back
      </Button>
    </a>
  </Box>
);

const ToggleButton = ({
  onClick,
  parentModule,
  isOpen,
}: {
  onClick: () => void;
  parentModule: string;
  isOpen?: boolean;
}) => (
  <Flex bg="#FFFFFF" p="10px 12px" alignItems="center" h="60px" w="100vw">
    <Icon
      style={{
        marginRight: '8px',
        color: 'transparent',
        fill: 'transparent',
        height: '20px',
        width: '20px',
      }}
      IconSVG={isOpen ? NetchexClose : NetchexHamburger}
      onClick={onClick}
    />
    <TextBodyLarge
      style={{
        fontSize: '23px',
      }}
    >
      {parentModule}
    </TextBodyLarge>
  </Flex>
);

const MobileNav = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { l2Module } = useRouteToNavLevels();
  const parentModule = l2Module === 'engagement' ? 'Engagement' : 'Performance';

  return (
    <>
      <GotoHomeButton />
      <ToggleButton onClick={onOpen} parentModule={parentModule} isOpen={isOpen} />
      <Drawer size="full" placement="left" isOpen={isOpen} onClose={onClose}>
        {/* REFER: https://github.com/chakra-ui/chakra-ui/issues/8604 */}
        <DrawerOverlay display="none" />
        <DrawerContent
          sx={{
            height: 'calc(100vh - 160px)',
            marginTop: '160px',
          }}
        >
          <DrawerBody>
            <AccordionNavigation isMobileNav onNavigationClick={onClose} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export { MobileNav };
